module.exports = __webpack_public_path__ + "media/images/logo/og_logo-0af93ff8883598590d92ca77e2ded522.png";